export const DATE_FORMAT = 'DD.MM.YYYY'
export const DATE_FORMAT_SLASH = 'DD/MM/YYYY'
export const DATE_FORM_FORMAT = 'YYYY-MM-DD'
export const DATE_FULL_MONTH_FORMAT = 'DD MMMM YYYY'
export const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss'
export const TIME_FORMAT = 'HH:mm:ss'
export const TIME_SHORT_FORMAT = 'HH:mm'
export const DATE_TIME_FORMAT_DAY_FIRST = 'DD.MM.YYYY HH:mm:ss'
export const DATE_TIME_FORM_SHORT_FORMAT_DAY_FIRST = 'DD.MM.YYYY HH:mm'
export const DATE_TIME_FORMAT_DASH = 'YYYY-MM-DD HH:mm'
export const DATE_FORMAT_WITH_SLASH = 'HH:mm / DD.MM.YY'
